import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { ChangePasswordComponent } from "../../../pages/auth-pages/change-password/change-password.component";
import { AuthStore } from '../../store/auth/auth.store';
import { BreadcrumbComponent } from "../breadcrumb/breadcrumb.component";
import { SidenavComponent } from "./sidenav/sidenav.component";
import { ToolbarSidebarComponent } from './toolbar-sidebar';
import { GoogleMapsLoaderService } from '@core/services/google-maps-loader.service';

@Component({
  selector: 'app-layout',
  imports: [ToastModule, SidenavComponent, RouterOutlet, BreadcrumbComponent, ProgressSpinnerModule, ChangePasswordComponent, ToolbarSidebarComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})

export class LayoutComponent implements OnInit {
  public readonly authStore = inject(AuthStore);

  private readonly _mapsLoaderService = inject(GoogleMapsLoaderService)

  transalteService: TranslateService = inject(TranslateService);

  constructor() {
    if (this.authStore.user()) {
      const userLang = this.authStore.user()?.lang || 'it';
      this.transalteService.use(userLang);
    } else {
      this.transalteService.use('it');
    }
  }

  ngOnInit(): void {
    this._loadGoogleMapsAPIKey();
  }

  private async _loadGoogleMapsAPIKey() {
    await this._mapsLoaderService.load();
  }
}
